import {isDefined} from '../../../../libs/shared/helpers/src/typescript/typeHelpers';
import {isStringTemplate, StringTemplate} from '../commons/stringTemplateModel';
import {Expression} from './expressionModel';
import {ExpressionRef, isExpressionRef} from './expressionRefModel';
import {ExpressionsEditorBaseErrorsEnum} from './expressionsEditorErrors';

function isReferenceResolved(ref: ExpressionRef, expressions: ReadonlyArray<Expression>) {
  return expressions.some((expression) => expression.id === ref.expression);
}

function isStringTemplateResolved(stringTemplate: StringTemplate, expressions: ReadonlyArray<Expression>) {
  return stringTemplate.template.every(
    (part) => !isExpressionRef(part) || isReferenceResolved(part, expressions),
  );
}

// @TODO: Change any for params!
export function getExpressionRefsValidationErrors(
  params: any,
  expressions: ReadonlyArray<Expression>,
): ReadonlyArray<ExpressionsEditorBaseErrorsEnum> {
  return Object.values(params)
    .map((param: any): ExpressionsEditorBaseErrorsEnum | undefined => {
      if (isExpressionRef(param) && !isReferenceResolved(param, expressions)) {
        return ExpressionsEditorBaseErrorsEnum.UNRESOLVED_REF;
      }

      if (isStringTemplate(param) && !isStringTemplateResolved(param, expressions)) {
        return ExpressionsEditorBaseErrorsEnum.UNRESOLVED_STRING_TEMPLATE;
      }

      return undefined;
    })
    .filter(isDefined);
}

// @TODO: Change any for params!
export function validateResolvedExpressionRefs(params: any, expressions: ReadonlyArray<Expression>) {
  return Object.values(params).every((param: any) => {
    if (isExpressionRef(param)) {
      return isReferenceResolved(param, expressions);
    }

    if (isStringTemplate(param)) {
      return isStringTemplateResolved(param, expressions);
    }

    return true;
  });
}
